import { AUTH_PAGE } from '@app/constants/page'

import type { AuthReturnUrlServiceOptions } from './types'
import type { Storage } from '@app/types'

const RETURN_URL = 'authReturnUrl'

export class AuthReturnUrlService {
  readonly #storage: Storage

  constructor ({ storage }: AuthReturnUrlServiceOptions) {
    this.#storage = storage
  }

  getReturnUrl (): string | null {
    const returnUrl = this.#storage.getItem(RETURN_URL)

    if (!this.isValidReturnUrl(returnUrl)) {
      this.clearReturnUrl()

      return null
    }

    return returnUrl
  }

  setReturnUrl (returnUrl: string): void {
    if (!this.isValidReturnUrl(returnUrl)) return

    this.#storage.setItem(RETURN_URL, returnUrl)
  }

  clearReturnUrl (): void {
    this.#storage.removeItem(RETURN_URL)
  }

  isValidReturnUrl (returnUrl: string | null): returnUrl is string {
    if (!returnUrl?.startsWith('/')) return false

    if (returnUrl.startsWith('//')) return false

    return returnUrl !== AUTH_PAGE.auth && !returnUrl.startsWith(`${AUTH_PAGE.auth}?`)
  }
}

const authReturnUrlService = new AuthReturnUrlService({ storage: sessionStorage })

export default authReturnUrlService
